<template>
    <v-card class="pa-3">
        <v-card-title>
            Editar Platillo
        </v-card-title>
        <v-card-text class="pb-0">
            <v-text-field label="Alimento" v-model="food_dish.name" outlined></v-text-field>
            <v-autocomplete v-model="food_dish.food_ids" item-value="id" class="mr-2" small-chips deletable-chips outlined item-text="name" hide-no-data label="Alimento" placeholder="Escribe para buscar" :loading="isLoadingAlimentos" :search-input.sync="searchAlimentos" :items="entries.alimentos" multiple>
                <template v-slot:item="data">
                    <v-list-item-content>
                        <v-list-item-title>{{data.item.name}}</v-list-item-title>
                        <v-list-item-subtitle style="font-size:10px;">{{data.item.food_group}}</v-list-item-subtitle>
                    </v-list-item-content>
                </template>
            </v-autocomplete>
        </v-card-text>
        <v-card-actions class="pt-0">
            <v-spacer/>
            <v-btn rounded class="elevation-0 ml-2 px-4" color="grey" @click="close()" style="color:white!important;">Cancelar</v-btn>
            <v-btn rounded class="elevation-0 ml-2 px-4" color="black" @click="save()" :disabled="valid" :loading="gris" style="color:white!important;">Guardar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from "axios"
export default {
    props:{
        food:Object
    },
    created(){
        this.entries.alimentos = this.food.food
        this.food_dish = [this.food].map(food=>{return{
            id:food.id,
            name:food.name,
            food_ids:food.food.map(f=>f.id)
        }})[0]
    },
    data: () => ({
        gris:false,
        entries:{
            alimentos: []
        },
        isLoadingAlimentos: false,
        searchAlimentos: null,
    }),	
    watch:{
        food:{
            handler(){
                this.entries.alimentos = this.food.food
                this.food_dish = [this.food].map(food=>{return{
                    id:food.id,
                    name:food.name,
                    food_ids:food.food.map(f=>f.id)
                }})[0]
            }
        },
        searchAlimentos(val){
            if (this.isLoadingAlimentos) return
            this.isLoadingAlimentos = true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/food?filter[name]='+val+'&itemsPerPage=100')
            .then(res => {
                this.entries.alimentos = this.entries.alimentos.concat(res.data)//.data)
            }).finally(() => (this.isLoadingAlimentos = false))
        }
    },
    computed:{
        valid(){
            if(
                (this.food_dish.name!=''&&this.food_dish.name!=undefined&&this.food_dish.name!=null)&&this.food_dish.food_ids.length>0
            ){
                return false
            }else{
                return true
            }
        }
    },
    methods:{
        close(){
            this.gris = false
            this.food_dish={
                name:'',
                food_ids:[]
            }
            this.$nextTick(() => {
                this.$emit("closeEditDialog", false);
            })
        },
        save(){
            this.gris = true
            axios.patch(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/food_dishes', this.food_dish).then(response=>{
                this.close()
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            })
        },
    }
}
</script>

<style>

</style>